import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'accounts'

export default {
  get (filters) {
    return Client.get(`${resource}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getAccountsPost (payload) {
    return Client.post(`${resource}/get/get_accounts_post`, parseFilters(payload))
      .then(response => response.data)
  },
  getAccount (id, filters) {
    return Client.get(`${resource}/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  },
  getAccountSummaryOverview (id, year, noProof, noOrder, storeOpen, showInactive, noNotifications, hasProject, onlyNotShipped, onlyNotDelivered, excludeStoreOnly = false, orderBySubmission = false) {
    return Client.get(`${resource}/account_summary_overview/${id}?year=${year}&noProof=${noProof}&noOrder=${noOrder}&storeOpen=${storeOpen}&showInactive=${showInactive}&noNotifications=${noNotifications}&hasProject=${hasProject}&notShipped=${onlyNotShipped}&notDelivered=${onlyNotDelivered}&excludeStoreOnly=${excludeStoreOnly}&orderBySubmission=${orderBySubmission}`)
      .then(response => response.data)
  },
  getNotSubmittedOverview (accountId, year) {
    return this.getAccountSummaryOverview(accountId, year, true, false, false, false, false, true, false, false, true, true)
  }
}
